import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

import { helper, http, api, route } from '../common/common';
import GeneralProfile from './settings/GeneralProfile';
import OrganizationInfo from './settings/OrganizationInfo';
import Manage from './settings/Manage';
import APIToken from './settings/APIToken';

const styles = (theme) => {
    return {
        view: {
            width: 600,
            height: 'calc(100% - 48px)',
            marginTop: 24,
            marginBottom: 24,
            marginLeft: 'auto',
            marginRight: 'auto',
            overflow: 'auto',
        },
        spinnerBackdrop: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
        },
        spinnerPlaceholder: {
            position: 'absolute',
            top: 'calc(50% - 40px)',
            left: 'calc(50% - 40px)',
            textAlign: 'center',
        },
        spinner: {
            color: theme.palette.text.disabled,
        },
    };
}

class Settings extends Component {
    constructor(props) {
        super(props);

        this.state = {
            profile: {},
            manageMember: false,
            // manageAPI: false,
        };

        this._cancelToken = http.CancelToken.source();
        this._pending = true;

        document.title = 'Settings \u00b7 Alpha2';
    }

    componentDidMount = () => {
        this._pending = true;
        this._requestProfile();
    }

    componentWillUnmount = () => {
        if (this._cancelToken) {
            this._cancelToken.cancel();
        }
    }

    render = () => {
        const { classes } = this.props;

        return (
            <div className={classes.view}>
                <GeneralProfile
                    info={this.state.profile}
                    onResetPassword={this._handleResetPassword}
                />
                <OrganizationInfo
                    info={this.state.profile}
                    onManage={this._handleManageOrganization}
                    // onManageAPI={this._handleManageAPI}
                    onLeave={this._handleLeaveOrganization}
                />
                {this._renderSpinner()}
                {this._renderManagePage()}
                {/* {this._renderAPITokenPage()} */}

            </div>
        );
    }

    _renderManagePage = () => {
        if (!this.state.profile.member_count) {
            return null
        }

        return (
            <Manage
                getAccessCode={this.props.getAccessCode}
                open={this.state.manageMember}
                onSave={this._handleOnManageSave}
                onCancel={this._handleOnManageCancel}
                onError={this._processError}
            />
        );
    }

    _renderAPITokenPage = () => {
        if (!this.state.profile.member_count) {
            return null
        }

        return (
            <APIToken
                getAccessCode={this.props.getAccessCode}
                open={this.state.manageAPI}
                onSave={this._handleOnManageAPISave}
                onCancel={this._handleOnManageAPICancel}
                onError={this._processError}
            />
        );
    }


    _renderSpinner = () => {
        if (!this._pending) {
            return null;
        }

        const { classes } = this.props;

        return (
            <div className={classes.spinnerBackdrop}>
                <div className={classes.spinnerPlaceholder}>
                    <CircularProgress
                        className={classes.spinner}
                        size={80}
                    />
                </div>
            </div>
        );
    }

    _handleResetPassword = () => {
        this._requestResetPassword();
    }

    _handleManageOrganization = () => {
        this.setState({
            manageMember: true,
        });
    }

    _handleManageAPI = () => {
        this.setState({
            manageAPI: true,
        });
    }

    _handleLeaveOrganization = () => {
        this._requestLeaveOrganization();
    }

    _handleOnManageSave = () => {
        this._pending = true;
        this.setState({
            profile: {},
            manageMember: false,
        });
        this._requestProfile();
    }

    _handleOnManageCancel = () => {
        this.setState({
            manageMember: false,
        });
    }

    _handleOnManageAPISave = () => {
        this._pending = true;
        this.setState({
            profile: {},
            manageAPI: false,
        });
        // this._requestProfile();
    }

    _handleOnManageAPICancel = () => {
        this.setState({
            manageAPI: false,
        });
    }


    _processError = (error) => {
        if (this.props.onError) {
            this.props.onError(error);
        }
    }

    _requestProfile = async () => {
        try {
            const response = await http.get(api.profile() + '/detail', {
                params: {
                    'access_code': this.props.getAccessCode(),
                },
                cancelToken: this._cancelToken.token,
            });

            this._pending = false;

            this.setState({
                profile: response.data,
            });
        } catch (error) {
            this._pending = false;

            if (http.isCancel(error)) {
                return;
            }

            this.setState({
                profile: {
                    first_name: 'Unknown',
                    last_name: '',
                    user_name: 'Unknown',
                    organization: 'Unknown',
                },
            });

            const e = helper.sanitizeError(error, 'Load Failed', 'Unable to load user profile');
            this._processError(e);
        }
    }

    _requestResetPassword = async () => {
        try {
            await http.post(api.profile() + '/reset', {
                'access_code': this.props.getAccessCode(),
            }, {
                    cancelToken: this._cancelToken.token,
                });

            const error = helper.makeError('Reset Successful',
                'The password reset link have been successfully sent to your email', 'warn_only');

            this._processError(error);
        } catch (error) {
            if (http.isCancel(error)) {
                return;
            }

            const e = helper.sanitizeError(error, 'Reset Failed', 'Unable to request password reset');
            this._processError(e);
        }
    }

    _requestLeaveOrganization = async () => {
        try {
            await http.post(api.organization() + '/quit', {
                'access_code': this.props.getAccessCode(),
            }, {
                    cancelToken: this._cancelToken.token,
                });

            this.props.setAccessCode('');
            route(this, '/home', '');
        } catch (error) {
            if (http.isCancel(error)) {
                return;
            }

            const e = helper.sanitizeError(error, 'Leave Failed', 'Unable to leave organization');
            this._processError(e);
        }
    }
}

Settings.propTypes = {
    getAccessCode: PropTypes.func.isRequired,
    setAccessCode: PropTypes.func.isRequired,
    onError: PropTypes.func,
}

export default withStyles(styles)(Settings);
